import React from "react";

import { Container } from "react-bootstrap";

import {
  Hexagon,
  HexContent,
  HexWrapper,
  StyledSection,
} from "./styledCategorySection";

const CategorySectionComponent = ({ categories }) => {
  return (
    <StyledSection>
      <Container>
        <CategoryRowComponent categories={categories} homePage />
      </Container>
    </StyledSection>
  );
};

export const CategoryRowComponent = ({ categories, homePage, refProp }) => {
  const scrollTo = () => {
    if (refProp && refProp.current) refProp.current.scrollIntoView();
  };
  return (
    <HexWrapper className="mx-auto py-4 p-sm-4" $homePage={homePage}>
      {categories.map((item) => {
        return (
          <Hexagon
            key={item.id}
            to={item.path}
            id={item.id}
            $homePage={homePage}
            onClick={scrollTo}
          >
            <svg viewBox="0 0 120 100" width="200" height="180">
              <path d="M38,2 L82,2 A12,12 0 0,1 94,10 L112,44 A12,12 0 0,1 112,56 L94,90 A12,12 0 0,1 82,98 L38,98 A12,12 0 0,1 26,90 L8,56 A12,12 0 0,1 8,44 L26,10 A12,12 0 0,1 38,2"></path>
            </svg>
            <HexContent title={item.title}>
              <img
                src={item.img}
                alt={item.alt}
                width="100"
                height="100"
                className="img-fluid"
              />
              <h3>{item.title}</h3>
            </HexContent>
          </Hexagon>
        );
      })}
    </HexWrapper>
  );
};

export default CategorySectionComponent;
